import React, { useEffect } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import { Typography, Box, IconButton } from "@material-ui/core";
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import InstagramIcon from '@material-ui/icons/Instagram';
import TelegramIcon from '@material-ui/icons/Telegram';
import { useDispatch, useSelector } from "react-redux";
import { axios } from "./../../../../axios";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
}));

const Footer = (props) => {
  const { className, ...rest } = props;
  
  const classes = useStyles();


  const dispatch = useDispatch();


  
  const token = useSelector((state) => state.token);
  const [data, setData] = React.useState([]);
  const [show, setShow] = React.useState('false');

  const headers = {
    Authorization: `Bearer ${token}`,
  };


  const GetData = async () => {
  
    try{
      const res = await axios.get(`settings/contact_us`, {
        headers:headers
      });
     // console.log(res.data,"setting")
    await  setData(res.data);
    await setShow(true)

    }catch(e)
    {
      // console.log(e.response,"setting")
    }
  
  }


 
  useEffect(() => {
    GetData();
  }, []);


  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Box borderRadius={20} style={{ backgroundColor: "white", padding: 10 }}>
        <Typography variant="h6" style={{ textAlign: "center" }}>
          کلیه حقوق این پنل متعلق به آنلاین بار ایران می باشد
        </Typography>
        {(data.result)!=undefined?
        <>
        <Typography variant="h6" style={{ textAlign: "center" ,paddingTop:5}}>
          {`تماس با ما : ${data.result?.tell} `}
        </Typography> 
        <div style={{marginTop:0,paddingTop:0, width:'100%',display:'flex',flex:1,justifyContent:'center',alignItems:'center'}}>
     
          <IconButton onClick={()=>window.open(`https://web.whatsapp.com/send?phone=${data.result?.whatsapp}`,'_blank')}  style={{padding:0}} color="primary" aria-label="add to shopping cart">
            <WhatsAppIcon />
          </IconButton>
          <IconButton onClick={()=>window.open(`https://t.me/${data.result?.telegram}`,'_blank')} style={{padding:0}} color="primary" style={{padding:0,paddingLeft:5,paddingRight:5}} aria-label="add to shopping cart">
            <TelegramIcon />
          </IconButton>
          <IconButton onClick={()=>window.open(`https://www.instagram.com/${data.result?.instagram}/`,'_blank')} style={{padding:0,paddingLeft:5}} color="primary" aria-label="add to shopping cart">
            <InstagramIcon />
          </IconButton>
         
        </div>
        </>
        :
        <Typography style={{display:'none'}}></Typography>
        }
      </Box>
    </div>
  );
};

Footer.propTypes = {
  className: PropTypes.string,
};

export default Footer;
